type ContactSceneProps = {
  weight: number;
};

export function ContactScene({ weight }: ContactSceneProps) {
  return (
    <group visible={weight > 0.001} position={[0, 0, -1]}>
      <ambientLight intensity={0.28 * weight} />
      <directionalLight color="#f1eeeb" intensity={0.64 * weight} position={[-2.4, 3.4, 2.8]} />
      <pointLight color="#ffffff" intensity={0.34 * weight} distance={7} position={[0, 1.4, 2.2]} />
      {/* <mesh position={[0, 0.15, 0]} scale={[1.3, 2.6, 1.3]}>
        <cylinderGeometry args={[0.42, 0.58, 1.8, 32]} />
        <meshStandardMaterial color="#d0cdcb" emissive="#d6d2cf" emissiveIntensity={0.08 * weight} metalness={0.2} roughness={0.28} transparent opacity={0.94 * weight} />
      </mesh>

      <mesh position={[0, 0.8, 0]} scale={[2.85, 2.85, 1]}>
        <torusGeometry args={[1.1, 0.05, 16, 64]} />
        <meshStandardMaterial color="#bbb8b6" emissive="#d2cfcc" emissiveIntensity={0.1 * weight} transparent opacity={0.9 * weight} />
      </mesh>

      <mesh position={[0, -1.3, 0]} rotation={[-Math.PI / 2, 0, 0]} scale={[10, 10, 1]}>
        <planeGeometry args={[1, 1]} />
        <meshStandardMaterial color="#b3b1b0" transparent opacity={0.9 * weight} />
      </mesh> */}
    </group>
  );
}
